import React from "react";

import { Col, Container, Row } from "react-bootstrap";
import { IoIosInformationCircleOutline } from "react-icons/io";

import {
  isiOS,
  isRunningStandalone,
} from "../../common/components/NavbarResponsive";
import { useNavigate } from "react-router-dom";

export default function PlanBottomBar({ nextPlanDay }) {
  const navigate = useNavigate();
  const plan = nextPlanDay();

  const paddingBottom = isiOS() && isRunningStandalone() ? "1.5rem" : "0.5rem";
  const planIsValid = plan && plan.id !== -1;
  const startUrl = planIsValid ? "/workout/" + plan.id + "/" + plan.workout.id + "/0/0/Content#" + plan.nWeek + "_" + plan.nDay : "";
  const workoutUrl = planIsValid ? "/workout/" + plan.id + "/" + plan.workout.id + "/0/0/Details" : "";

  return (
    <>
      <div
        onContextMenu={(e) => e.preventDefault()}
        className="align-self-center text-center plan-bottom-navbar"
        style={{ paddingBottom: paddingBottom }}
      >
        {!planIsValid ? (
          <></>
        ) :
          (
            <Container
              className="blur m-auto shadow-sm rounded-pill py-1"
              style={{
                background: "#ffffffb8",
                width: "96%",
                border: "1px solid #eeeded"
              }}
            >
              <Row className="px-2 py-1">
                <Col xs={2} className="text-start align-self-center px-0">
                  <img
                    src={plan.workout.cover}
                    className="rounded-pill"
                    alt={plan.workout.name}
                    style={{ width: 48, height: 48, cursor: "pointer" }}
                    onClick={() => { navigate(workoutUrl) }}
                  />
                </Col>
                <Col xs={8} className="text-start px-0">
                  <p
                    className="mb-0 subtitle-clickable"
                    style={{ fontSize: 12 }}
                    onClick={() => { navigate(workoutUrl) }}
                  >
                    {"Prossimo allenamento"}
                    <IoIosInformationCircleOutline
                      className="subtitle-clickable"
                      size={14}
                      style={{ marginLeft: 4 }}
                    />
                  </p>
                  <p
                    className="mb-0 title-clickable"
                    style={{ fontSize: 14 }}
                    onClick={() => { navigate(workoutUrl) }}
                  >
                    {plan.workout.name}
                  </p>
                </Col>
                <Col xs={2} className="text-end align-self-center px-0">
                  <p className="mb-0 title-clickable" style={{ marginRight: 4, fontWeight: "bold" }} onClick={() => { navigate(startUrl) }}> Inizia </p>
                </Col>
              </Row>
            </Container>
          )}
      </div >
    </>
  );
}
